import {ContactMessageDb} from '@cp/model';
import {doc, DocumentReference} from 'firebase/firestore';
import getContactMessageCollection from './getContactMessageCollection';

export default function getContactMessageDocRef(messageId: string): DocumentReference<ContactMessageDb> {
  return doc(getContactMessageCollection(), messageId);
}
